(() => {
  if (window.BLGEmailSignupConsent) {
    window.BLGEmailSignupConsent.init();
    return;
  }

  const SELECTOR = '[data-blg-marketing-consent]';
  const TOGGLE_SELECTOR = '[data-blg-marketing-consent-toggle]';
  const BODY_SELECTOR = '[data-blg-marketing-consent-body]';
  const CHECKBOX_SELECTOR = '[data-blg-marketing-consent-checkbox]';
  const SUBMIT_SELECTOR = '[data-blg-marketing-consent-submit]';

  const setExpandedState = (toggle, body, expanded) => {
    const openLabel = toggle.dataset.blgMarketingConsentOpenLabel;
    const closeLabel = toggle.dataset.blgMarketingConsentCloseLabel;

    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? closeLabel : openLabel;
    body.hidden = !expanded;
    body.setAttribute('aria-hidden', expanded ? 'false' : 'true');
  };

  const bindConsent = consent => {
    if (consent.dataset.blgMarketingConsentBound === 'true') {
      return;
    }

    const toggle = consent.querySelector(TOGGLE_SELECTOR);
    const body = consent.querySelector(BODY_SELECTOR);
    const checkbox = consent.querySelector(CHECKBOX_SELECTOR);
    const submitButton = consent.closest('form')?.querySelector(SUBMIT_SELECTOR);

    if (!toggle || !body || !checkbox || !submitButton) {
      return;
    }

    consent.dataset.blgMarketingConsentBound = 'true';
    setExpandedState(toggle, body, false);

    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      setExpandedState(toggle, body, !expanded);
    });

    const syncSubmitState = () => {
      submitButton.disabled = !checkbox.checked;
    };

    checkbox.addEventListener('change', syncSubmitState);
    syncSubmitState();
  };

  const init = () => {
    document.querySelectorAll(SELECTOR).forEach(bindConsent);
  };

  window.BLGEmailSignupConsent = { init };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  init();
})();
